export default "__VITE_ASSET__qSwYKaPu__"